import { CLASS_ACTIONS } from "./action";

// ----------------------------------------------------------------------

const classInitialState = {
  data: [],
  classData: {},
  loading: false,
  pagination: {
    currentPage: 0,
    totalPages: 1,
    perPage: 1,
    total: 1,
  },
};

// eslint-disable-next-line default-param-last
export function classReducer(state = classInitialState, action) {
  switch (action.type) {
    case CLASS_ACTIONS.SET_STATE:
      return { ...state, ...action.payload };
    case CLASS_ACTIONS.DESTROY:
      return classInitialState;
    default:
      return state;
  }
}
